import { omit } from 'lodash';
import moment from 'moment-timezone';

export default {
  getLocalDateFromString: date => {
    if (date) {
      // Check if value is date only or date + time
      if (date.length === 10) {
        const momentDate = moment(date);
        return momentDate
          .add(new Date().getTimezoneOffset(), 'minutes')
          .toDate();
      }
      return new Date(date);
    }
    return null;
  },
  isoStringToMoment: (date, allDay, timeZone = moment.tz.guess()) => {
    if (allDay) {
      return moment(date);
    }
    return moment(date).tz(timeZone);
  },
  dateToISOString: (date, allDay, timeZone = moment.tz.guess()) => {
    if (allDay) {
      return moment(date).format('YYYY-MM-DD');
    }
    return moment.tz(date, timeZone).toISOString();
  },
  omitTimeZoneWithoutTimes: eventSegment => {
    if (!(eventSegment.start_at && eventSegment.end_at)) {
      return omit(eventSegment, 'time_zone');
    }
    return eventSegment;
  }
};



// WEBPACK FOOTER //
// ./webpack/lib/utils/date.js